<div class="bg-gray-200 px-2 py-20">

  <div id="features" class="mx-auto max-w-6xl">
    <div class="flex flex-wrap">
      <div class="w-full">
        <div class="text-center mx-auto max-w-2xl">
          <p class="text-accent-500 text-5xl font-secondary">
            What we Offer
          </p>
          <h2 class="font-bold text-3xl sm:text-4xl md:text-[40px] text-dark">
            Get Extra Services
          </h2>
        </div>
      </div>
    </div>
    <ul class="mt-16 grid grid-cols-1 gap-6 text-center text-slate-700 md:grid-cols-3">
      <li class="rounded-xl bg-white px-6 py-8 shadow-sm group">
        <mat-icon class="icon-size-12 text-accent-500" svgIcon="mat_solid:car_rental"></mat-icon>
        <h3 class="my-3 font-display font-medium group-hover:text-primary-500 transition-all duration-300">Car Hire</h3>
        <p class="mt-1.5 text-sm leading-6 text-secondary-500">
          Book your desired car hire locally and internationally for you trip before time
        </p>
      </li>
      <li class="rounded-xl bg-white px-6 py-8 shadow-sm group">
        <mat-icon class="icon-size-12 text-accent-500" svgIcon="heroicons_solid:user-group"></mat-icon>
        <h3 class="my-3 font-display font-medium group-hover:text-primary-500 transition-all duration-300">Corporate /
          group tour</h3>
        <p class="mt-1.5 text-sm leading-6 text-secondary-500">
          Contact us to see what special corporate/group discounted rates we can get you.
        </p>

      </li>
      <li class="rounded-xl bg-white px-6 py-8 shadow-sm group">
        <mat-icon class="icon-size-12 text-accent-500" svgIcon="heroicons_solid:clipboard-document-list"></mat-icon>
        <h3 class="my-3 font-display font-medium group-hover:text-primary-500 transition-all duration-300">Portuguese
          documentation</h3>
        <p class="mt-1.5 text-sm leading-6 text-secondary-500">
          Assistance with applications for Portuguese passports, Cartao de Cidadao etc. Through the Portuguese consulate
        </p>

      </li>
      <li class="rounded-xl bg-white px-6 py-8 shadow-sm group">
        <mat-icon class="icon-size-12 text-accent-500" svgIcon="mat_outline:airplane_ticket"></mat-icon>
        <h3 class="my-3 font-display font-medium group-hover:text-primary-500 transition-all duration-300">Air ticket
          and accommodation</h3>
        <p class="mt-1.5 text-sm leading-6 text-secondary-500">
          Air tickets on all Domestic and International airlines. Accommodation locally and internationally</p>
      </li>
      <li class="rounded-xl bg-white px-6 py-8 shadow-sm group">
        <mat-icon class="icon-size-12 text-accent-500" svgIcon="mat_solid:directions_boat_filled"></mat-icon>
        <h3 class="my-3 font-display font-medium group-hover:text-primary-500 transition-all duration-300">
          Cruise
        </h3>
        <p class="mt-1.5 text-sm leading-6 text-secondary-500">
          We offer Cruise packages</p>
      </li>
      <li class="rounded-xl bg-white px-6 py-8 shadow-sm group">
        <mat-icon class="icon-size-12 text-accent-500" svgIcon="mat_solid:airport_shuttle"></mat-icon>
        <h3 class="my-3 font-display font-medium group-hover:text-primary-500 transition-all duration-300">Cargo
          Services</h3>
        <p class="mt-1.5 text-sm leading-6 text-secondary-500">Referrals for clients interested in cargo services</p>
      </li>
    </ul>
  </div>
<div>